import Image from "next/image";

const CredibilityStrip = ({ label, items }) => (
  <div className="bg-secondary/50 border-y border-primary/5 py-8 md:py-10">
    <div className="container px-4">
      <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-12 justify-center">
        <span className="text-sm uppercase tracking-[0.2em] text-muted-foreground font-sans font-semibold shrink-0 opacity-70">
          {label}
        </span>
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {items.map((item) => {
            const logo = (
              <span className="bg-white rounded-xl px-5 py-4 inline-flex items-center justify-center shadow-sm border border-black/[0.03] hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 relative h-16 md:h-24 w-32 md:w-48 overflow-hidden">
                <Image 
                  src={item.logo} 
                  alt={`${item.name} - ${label} BookMyPooja`} 
                  fill
                  className="object-contain p-2" 
                  sizes="(max-width: 768px) 128px, 192px"
                />
              </span>
            );
            return item.url ? (
              <a key={item.name} href={item.url} target="_blank" rel="noopener noreferrer" className="block">
                {logo}
              </a>
            ) : (
              <span key={item.name}>{logo}</span>
            );
          })}
        </div>
      </div>
    </div>
  </div>
);

export default CredibilityStrip;
